import { FC } from 'react';
import { format } from 'date-fns';
import {
  FormControl,
  FormLabel,
  Input,
  Stack,
  Button,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  ModalFooter,
  Modal,
  Textarea,
  CheckboxGroup,
  Checkbox,
} from '@chakra-ui/react';
import { useEditDetailStore } from '../../../hooks';

type Props = ReturnType<typeof useEditDetailStore>;

export const CrawlerDetailConfirmModalView: FC<Props> = ({
  isOpenModal,
  onCloseModal,
  values,
  onEditCrawlerDetail,
}) => (
  <Modal
    isOpen={isOpenModal}
    onClose={onCloseModal}
    size="4xl"
    blockScrollOnMount
  >
    <ModalOverlay />
    <ModalContent maxHeight="90vh">
      <ModalHeader p="40px">バージョンの更新</ModalHeader>
      <ModalCloseButton />
      <ModalBody overflowY="auto" px="40px">
        <Stack spacing="6" direction="column">
          <FormControl>
            <FormLabel>バージョン</FormLabel>
            <Input
              type="text"
              value={values.version}
              width="240px"
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
          <FormControl>
            <FormLabel>説明</FormLabel>
            <Textarea
              value={values.description}
              rows={3}
              variant="flushed"
              isReadOnly
            />
          </FormControl>
          <FormControl>
            <FormLabel>リリース日</FormLabel>
            <Input
              type="text"
              value={
                values.releasedAt instanceof Date
                  ? format(values.releasedAt, 'yyyy-MM-dd')
                  : ''
              }
              width="240px"
              variant="flushed"
              isReadOnly
            />
          </FormControl>
          <FormControl>
            <FormLabel>手動実行対応</FormLabel>
            <CheckboxGroup value={values.adhocSupportedIntervals}>
              <Stack spacing={8} direction="row">
                <Checkbox value="hourly" isReadOnly pointerEvents="none">
                  hourly
                </Checkbox>
                <Checkbox value="daily" isReadOnly pointerEvents="none">
                  daily
                </Checkbox>
                <Checkbox value="weekly" isReadOnly pointerEvents="none">
                  weekly
                </Checkbox>
                <Checkbox value="monthly" isReadOnly pointerEvents="none">
                  monthly
                </Checkbox>
                <Checkbox value="none" isReadOnly pointerEvents="none">
                  手動実行
                </Checkbox>
              </Stack>
            </CheckboxGroup>
          </FormControl>
          <FormControl>
            <FormLabel>UI表示テンプレート</FormLabel>
            <Textarea
              value={values.configTemplate}
              rows={8}
              variant="flushed"
              isReadOnly
            />
          </FormControl>
          <FormControl>
            <FormLabel>リリースチャンネル</FormLabel>
            <CheckboxGroup value={values.releasedChannel}>
              <Stack spacing={8} direction="row">
                <Checkbox value="stable" isReadOnly pointerEvents="none">
                  安定版
                </Checkbox>
                <Checkbox value="beta" isReadOnly pointerEvents="none">
                  ベータ版
                </Checkbox>
              </Stack>
            </CheckboxGroup>
          </FormControl>
        </Stack>
        <Text mt="60px" align="center" fontWeight="bold">
          上記の内容でバージョン情報を更新しますか？
        </Text>
      </ModalBody>
      <ModalFooter gap="16px" justifyContent="center" p="40px">
        <Button
          w="140px"
          colorScheme="blackAlpha"
          variant="outline"
          onClick={onCloseModal}
        >
          キャンセル
        </Button>
        <Button
          colorScheme="blackAlpha"
          w="140px"
          onClick={onEditCrawlerDetail}
        >
          更新
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
